<div class="p-3">
  <h2 mat-dialog-title>Error de conexión</h2>
  <div mat-dialog-content>
    <p>{{ data?.message || 'No se ha podido establecer conexión con el servidor.' }}</p>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-between mt-3">
    <button class="btn btn-outline-levelab" (click)="close()">Cerrar</button>
    <button class="btn btn-levelab" (click)="retry()">Reintentar</button>
  </div>
</div>

